export const signalRKeysEnum = {
  websiteStorageSize: "WebsiteStorageSize",
};
